import { render, staticRenderFns } from "./taskList.vue?vue&type=template&id=599d5008&scoped=true"
import script from "./taskList.vue?vue&type=script&lang=js"
export * from "./taskList.vue?vue&type=script&lang=js"
import style0 from "./taskList.vue?vue&type=style&index=0&id=599d5008&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599d5008",
  null
  
)

export default component.exports